module.exports = __webpack_public_path__ + "static/media/cover.86f296b1.png";